export function formatInitialsName(name) {
  if (!name) return "";
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) {
    return parts[0][0].toUpperCase();
  }
  const first = parts[0][0];
  const last = parts[parts.length - 1][0];
  //sobrenome primeiro (LastName + FirstName)
  return (last + first).toUpperCase();
}